export const activitiesParser = data =>
  data.map(item => [item.name, item.countryCode, item.location]);
